import type { FC, ReactNode } from 'react'

import { Fragment } from 'react'
import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import { LegalPage } from '@/components/legal/legal-page'

interface TermsSection {
    title: string
    paragraphs: Array<string>
}

const TERMS: Array<TermsSection> = [
    {
        title: "§ 1 Geltungsbereich",
        paragraphs: [
            "Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung der SaaS-Plattform „ConcreTrack“ (nachfolgend „Plattform“), die von der BBA GmbH, Silberberger Chaussee 14, 15526 Bad Saarow (nachfolgend „Anbieter“), angeboten wird.",
            "Das Angebot richtet sich ausschließlich an Unternehmer im Sinne von § 14 BGB. Eine Nutzung durch Verbraucher im Sinne von § 13 BGB ist nicht vorgesehen.",
            "Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu."
        ]
    },
    {
        title: "§ 2 Vertragsgegenstand",
        paragraphs: [
            "Der Anbieter stellt dem Kunden die Plattform ConcreTrack als cloudbasierte Software-as-a-Service-Lösung zur Verfügung. Der Zugriff erfolgt über das Internet mittels eines Webbrowsers.",
            "Leistungsbeschreibung, Funktionsumfang und Vergütung ergeben sich aus dem jeweiligen Einzelvertrag zwischen Anbieter und Kunde."
        ]
    },
    {
        title: "§ 3 Leistungsbeschreibung",
        paragraphs: [
            "ConcreTrack dient dem intelligenten Monitoring von Beton. Die Plattform ermöglicht die Echtzeitüberwachung von Betonqualität und -festigkeit durch die Verbindung von Baustelle, Sensorik und digitaler Plattform.",
            "Der Anbieter entwickelt die Plattform kontinuierlich weiter und behält sich Änderungen des Funktionsumfangs vor, soweit dadurch der vertraglich vereinbarte Leistungsumfang nicht wesentlich eingeschränkt wird."
        ]
    },
    {
        title: "§ 4 Verfügbarkeit",
        paragraphs: [
            "Der Anbieter sichert eine Verfügbarkeit der Plattform von 99,5 % im Jahresmittel zu. Hiervon ausgenommen sind geplante Wartungszeiten, die der Anbieter mit angemessener Frist ankündigt.",
            "Der Anbieter ist berechtigt, Wartungsarbeiten durchzuführen, die die Verfügbarkeit vorübergehend einschränken können. Geplante Wartungsarbeiten finden nach Möglichkeit außerhalb der üblichen Geschäftszeiten statt.",
            "Störungen, die außerhalb des Einflussbereichs des Anbieters liegen, insbesondere höhere Gewalt oder Störungen des Internets, stellen keine Pflichtverletzung des Anbieters dar."
        ]
    },
    {
        title: "§ 5 Nutzungsrechte",
        paragraphs: [
            "Der Kunde erhält für die Dauer des Vertrags das einfache, nicht ausschließliche, nicht übertragbare und auf die Vertragslaufzeit beschränkte Recht, die Plattform bestimmungsgemäß zu nutzen.",
            "Dem Kunden ist es untersagt, die Plattform zu vervielfältigen, zu dekompilieren, zu disassemblieren oder auf andere Weise den Quellcode zu ermitteln, soweit dies nicht gesetzlich ausdrücklich erlaubt ist.",
            "Die vom Kunden eingegebenen Daten bleiben Eigentum des Kunden. Der Anbieter verarbeitet diese Daten ausschließlich zur Erfüllung des Vertrags."
        ]
    },
    {
        title: "§ 6 Pflichten des Kunden",
        paragraphs: [
            "Der Kunde ist verpflichtet, seine Zugangsdaten geheim zu halten und vor dem Zugriff Dritter zu schützen.",
            "Der Kunde stellt sicher, dass seine Nutzung der Plattform im Einklang mit den geltenden gesetzlichen Bestimmungen erfolgt.",
            "Der Kunde ist für die Sicherung seiner Daten in angemessenen Abständen selbst verantwortlich, soweit der Anbieter die Datensicherung nicht vertraglich übernommen hat."
        ]
    },
    {
        title: "§ 7 Haftungsbeschränkung",
        paragraphs: [
            "Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit sowie für Schäden, die auf Vorsatz oder grober Fahrlässigkeit beruhen.",
            "Bei leicht fahrlässiger Verletzung einer wesentlichen Vertragspflicht (Kardinalpflicht) ist die Haftung des Anbieters auf den vertragstypischen, vorhersehbaren Schaden begrenzt.",
            "Im Übrigen ist die Haftung für leichte Fahrlässigkeit ausgeschlossen.",
            "Die vorstehenden Haftungsbeschränkungen gelten auch für die persönliche Haftung der Mitarbeiter, Vertreter und Organe des Anbieters."
        ]
    },
    {
        title: "§ 8 Datenschutz",
        paragraphs: [
            "Der Anbieter verarbeitet personenbezogene Daten des Kunden im Einklang mit den geltenden datenschutzrechtlichen Bestimmungen. Einzelheiten ergeben sich aus der Datenschutzerklärung. Soweit der Anbieter personenbezogene Daten im Auftrag des Kunden verarbeitet, schließen die Parteien einen gesonderten Vertrag über die Auftragsverarbeitung."
        ]
    },
    {
        title: "§ 9 Laufzeit und Kündigung",
        paragraphs: [
            "Laufzeit und Kündigungsfristen ergeben sich aus dem jeweiligen Einzelvertrag zwischen Anbieter und Kunde.",
            "Das Recht beider Parteien zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.",
            "Nach Beendigung des Vertrags wird der Zugang des Kunden zur Plattform deaktiviert. Der Kunde kann seine Daten innerhalb von 30 Tagen nach Vertragsende exportieren. Danach werden die Daten unter Beachtung gesetzlicher Aufbewahrungsfristen gelöscht."
        ]
    },
    {
        title: "§ 10 Schlussbestimmungen",
        paragraphs: [
            "Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.",
            "Ist der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen, ist ausschließlicher Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit diesem Vertrag Frankfurt (Oder).",
            "Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. An die Stelle der unwirksamen Bestimmung tritt eine wirksame Regelung, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.",
            "Änderungen und Ergänzungen dieser AGB bedürfen der Schriftform. Dies gilt auch für die Aufhebung dieses Schriftformerfordernisses."
        ]
    }
]

const Agb: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='AGB'
                path='/agb'
                description='Allgemeine Geschäftsbedingungen der BBA GmbH für die Nutzung der SaaS-Plattform ConcreTrack.'
            />

            <LegalPage
                title='Allgemeine Geschäftsbedingungen'
                intro='für die Nutzung der SaaS-Plattform ConcreTrack der BBA GmbH'
                updated='Stand: April 2026'
            >
                {TERMS.map((section) => (
                    <Fragment key={section.title}>
                        <h2>{section.title}</h2>

                        {section.paragraphs.map((paragraph, index) => (
                            <p key={paragraph} className='flex gap-3'>
                                {section.paragraphs.length > 1 && (
                                    <span className='shrink-0 font-mono text-sm leading-[1.85] text-foreground/70'>
                                        ({index + 1})
                                    </span>
                                )}

                                <span>{paragraph}</span>
                            </p>
                        ))}
                    </Fragment>
                ))}
            </LegalPage>
        </Layout>
    )
}

export default Agb
